<template>
  <b-form-group label="Logradouro Tipo:">
    <b-form-select v-model="valor" :options="tipos"></b-form-select>
  </b-form-group>
</template>

<style lang="scss" scoped></style>

<script>
import logradourosTipos from "./logradourosTipos.json";
export default {
  name: "InputLogradouroTipo",
  data() {
    return {
      tipos: logradourosTipos
    };
  },
  computed: {
    valor: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  props: ["value"],
  methods: {}
};
</script>
